/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { createFeatureSelector, createSelector } from '@ngrx/store';
import { SystemManagerState } from './system-manager-reducer';
import * as SystemManagerReducer from './system-manager-reducer';

export const selectSystemManagerState = createFeatureSelector<SystemManagerState>(
  SystemManagerReducer.SystemManagerKey
);

export const selectVisibleInvisibleSystems = createSelector(selectSystemManagerState, (state) => {
  return state.visibleInvisibleSystems;
});

export const selectExportReturnCodes = createSelector(selectSystemManagerState, (state) => {
  return state.returnCodeExport;
});

export const selectFileName = createSelector(selectSystemManagerState, (state) => state.fileName);